import BaseListPresenter from "../../base/BaseListPresenter";
import { formatDate } from "../../components/common/Converter";
import { renderToStaticMarkup } from "react-dom/server";

class ServiceRequestLogPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }

  init() {
    const where =
      this.view.getUser()?.roles[0]?.id === "Super Admin"
        ? {}
        : {
            $or: [
              { "user.id": this.view.getUser().id },
              { "request.id": this.view.getUser().employee.id },
              { "employee.id": this.view.getUser().employee.id },
            ],
          };
    console.log("where: ", where);
    this.limit = 10;
    this.where = where;
    this.search = {};
    this.filter = {};
    this.include = ["user", "employee", "request"];
    this.keys = [
      "employee.Firstname",
      "employee.Middlename",
      "employee.surname",
      "createdAt",
      "workFlow",
      "activity",
      "message",
      "user",
      "selectedFiles",
      "request.Firstname",
      "request.Middlename",
      "request.surname",
    ]; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }

  printContent(objects) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <div style={{ margin: "0 2rem" }}>
          <table>
            <thead>
              <tr>
                <td colSpan="3" style={{ height: "10rem" }}></td>
              </tr>
              <tr>
                <th>Date</th>
                <th>User</th>
                <th>Activity</th>
                <th>Message</th>
              </tr>
            </thead>
            <tbody>
              {objects.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{formatDate(item.createdAt)}</td>
                    <td>{`${item.employee.Firstname} ${item.employee.Middlename} ${item.employee.surname}`}</td>
                    <td>{item.activity}</td>
                    <td>{item.message}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  GeneratePDF = async (objects) => {
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";

    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow.document;
    const printContentElement = this.printContent(objects);
    const printContentHTML = renderToStaticMarkup(printContentElement);

    iframeDoc.open();
    iframeDoc.write(
      `<html><head>
      <style>
        body {
          font-family: Arial, sans-serif;
          margin: 0;
          padding: 0;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 1.1rem;
          text-align: left;
        }
        th, td {
        padding-top: .5rem;
        padding-bottom: .5rem;
        border-bottom: 1px solid #ddd;
        padding-right: .5rem;
        padding-left: .5rem;
        }
        
          .header {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            width: 100%;
            height: 125px;
            z-index: 1000;
          }
          @page {
            margin: 0;
            size: auto;
          }
@media print {
      th {
        background-color: #2e6bc7 !important;
        color: #fff;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
      tr:nth-child(even) td {
        background-color: #e1e7f0 !important;
          -webkit-print-color-adjust: exact;
      }
      tr:nth-child(odd) td {
          -webkit-print-color-adjust: exact;
      }
    }
      </style></head><body>`
    );

    // Adding the image as a fixed header
    iframeDoc.write(
      `<div class='header'>
        <div style="padding: 1rem; text-align: center;">
          <img src="${"/BI.png"}" width="100%" height="125" />
        </div>
      </div>`
    );
    iframeDoc.write(printContentHTML);

    // Adding the script for the onload callback function
    iframeDoc.write(`<script>
      window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          }
      };
    </script>`);
    iframeDoc.write("</body></html>");
    iframeDoc.close();
  };

  GenerateExcel = async (objects) => {
    let csvContent = "DATE,USER,ACTIVITY,MESSAGE\n"; // CSV header

    objects.forEach((item) => {
      const logDate = this.wrapInQuotes(formatDate(item.createdAt));
      const user = this.wrapInQuotes(
        `${item.employee.Firstname} ${item.employee.Middlename} ${item.employee.surname}`
      );
      const activity = this.wrapInQuotes(item.activity);
      const message = this.wrapInQuotes(item.message);

      csvContent += `${logDate},${user},${activity},${message}\n`;
    });

    // Create a blob from CSV content
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    // Create a link element and trigger download
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `Audit Log Report-${new Date().toISOString().split("T")[0]}.csv`
    );
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  // Helper function to wrap values in quotes if necessary
  wrapInQuotes = (value) => {
    // Convert to string and check if it contains a comma or new line
    const strValue = String(value);
    if (strValue.includes(",") || strValue.includes("\n")) {
      return `"${strValue.replace(/"/g, '""')}"`; // Wrap in quotes and escape any existing quotes
    }
    return strValue;
  };
}
export default ServiceRequestLogPresenter;
